<script>
/*
  Vision Venture — Banner Carousel
  - Thin wrapper: reuse StandardV2BannerCarousel เดิม
  - เพิ่ม CSS override ให้ image เป็น object-fit: cover (แทน contain จาก Vuetify default)
*/
import StandardV2BannerCarousel from "@/components/profile/StandardV2BannerCarousel.vue";

export default {
  name: "VvBannerCarousel",
  components: {
    StandardV2BannerCarousel
  },
  inheritAttrs: false,
  props: {
    bannerList: {
      default: null,
      type: Array
    },
    imageRatio: {
      default: "1.7777777778",
      type: String
    },
    dataTestPrefix: {
      default: "vv-banner-carousel",
      type: String
    },
    profile: {
      default: () => ({}),
      type: Object
    }
  }
};
</script>

<template>
  <div class="vv-banner-carousel">
    <StandardV2BannerCarousel
      :banner-list="bannerList"
      :data-test-prefix="dataTestPrefix"
      :image-ratio="imageRatio"
      :profile="profile"
      v-bind="$attrs"
    />
  </div>
</template>

<style lang="scss" scoped>
/* Force image to cover the frame instead of Vuetify's default contain */
.vv-banner-carousel :deep(.v-img__img),
.vv-banner-carousel :deep(.banner-carousel-v2__media) {
  object-fit: cover;
}
</style>
